export default theme => ({
  root: {},
  row: {
    height: '42px',
    display: 'flex',
    alignItems: 'center',
    marginTop: theme.spacing.unit
  },
  spacer: {
    flexGrow: 1
  },
  addButton: {
    paddingLeft: theme.spacing.unit * 2,
    paddingRight: theme.spacing.unit * 2
  },
  cancelIcon : {
    marginRight : theme.spacing.unit
  },
  cancelButton : {
    borderColor: theme.palette.danger.main + '!important',
    color: theme.palette.danger.main + '!important'
  },
  deleteIcon: {
    marginRight: theme.spacing.unit
  },
  deleteButton: {
    color: theme.palette.danger.main,
    marginRight: theme.spacing.unit
  },
  searchInput: {
    marginRight: theme.spacing.unit
  }
});
